// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/add-on-get-app-qrcode/add-on-get-app-qrcode.component.scss
// module id = 604
// module chunks = 0